import { LoadingIcon } from '@/components/controls';
import { useNichePersonImage } from '@/hooks';
import { toProperCase } from '@/utils';
import { Map as MapIcon } from '@mui/icons-material';
import {
  Box,
  Card,
  CardHeader,
  CardMedia,
  IconButton,
  Stack,
  Tooltip,
} from '@mui/material';
import { FlagAvatar } from './FlagAvatar';
import { SuspectOccurrence } from './SuspectOccurrence';

export function Suspect({ suspect, onOptionClick, onShowMapClick }) {
  const { subject, occurrences = [] } = suspect;
  const {
    query: {
      data: imageSrc,
      isLoading: imageLoading,
      isFetching: imageFetching,
    },
  } = useNichePersonImage(subject?.id);

  return (
    <Card variant="outlined" sx={{ minWidth: 240 }}>
      <CardHeader
        avatar={<FlagAvatar />}
        action={
          <Stack direction="row" spacing={0.5} sx={{ alignItems: 'center' }}>
            <LoadingIcon isLoading={imageLoading || imageFetching} />
            {subject?.addresses?.length > 0 && (
              <Tooltip title="Show map">
                <IconButton size="small" onClick={onShowMapClick}>
                  <MapIcon sx={{ fontSize: 'inherit' }} />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
        }
        title={toProperCase(
          [subject?.forenames, subject?.surname].filter(Boolean).join(' '),
        )}
      />
      {imageSrc ? (
        <CardMedia
          component="img"
          sx={{ minHeight: 240, width: '100%' }}
          image={imageSrc}
          alt="Photo of suspect"
        />
      ) : (
        <Box
          sx={(theme) => ({
            height: 240,
            width: '100%',
            bgcolor: theme.palette.mode === 'dark' ? 'grey.600' : 'grey.300',
          })}
        />
      )}
      <Stack spacing={1} sx={{ p: 1 }}>
        {occurrences.map((occurrence) => (
          <SuspectOccurrence
            key={occurrence.id}
            personId={subject?.id}
            occurrence={occurrence}
            onOptionClick={onOptionClick}
          />
        ))}
      </Stack>
    </Card>
  );
}
